function changeAriaHidden ($, val) {
  if ($(".top-bar")) $(".top-bar").attr("aria-hidden", val);
  if ($(".main-layout")) $(".main-layout").attr("aria-hidden", val);
  if ($(".password-recovery-modal")) $(".password-recovery-modal").attr("aria-hidden", !val);
}

var ChangePasswordForm = Backbone.Epoxy.View.extend({


  template: 'modals.passwordRecoveryEmailForm',

  events: {
    'click #recoverPassword': 'recoverPassword',
    'click #recoveredPassword': 'closeModal',
    'focus .form-control': function(e) { this.$(e.target).select(); },
    'submit #emailForm': function() { return false; }
  },

  initialize: function() {
    this.hasRendered = false;
  },

  cleanup: function() {
  },

  beforeRender: function() {
    if (this.hasRendered) {
      return false;
    }
    this.hasRendered = true;
    return true;
  },

  /**
   * Boilerplate after render for modals.
   */
  afterRender: function() {
    this.$el.modal({
      show: false
    });

    this.$el.on('hide.bs.modal', function(e) {
      changeAriaHidden($, false);

      if ('parentIFrame' in window) {
        parentIFrame.sendMessage({event: 'closeModal'});
        $('body').css('background', 'transparent');
      } else {
        console.log('No parent, oh noes')
      }
    });
    this.applyBindings();
  },

  /**
   * Show this form.
   */
  show: function(email) {
    Backbone.Validation.unbind(this.model);
    this.model.set("email", "");
    this.model.set("errorMessage", "");
    this.model.set("successMessage", "");
    this.model.set("validationSuspended", true);

    changeAriaHidden($, true);

    if (email) {
      this.model.set('email', email);
    }

    Backbone.Validation.bind(this.model);
    this.$el.modal('show');
    if ('parentIFrame' in window) {
      parentIFrame.sendMessage({event: 'openModal'});
      $('body').css('background', '#fbfbfb');
      //$('.modal-backdrop').hide();
    } else {
      console.log('No parent, oh noes')
    }

    if (!email) {
      this.$('.form-control').focus();
    } else {
      this.$('#recoverPassword').focus();
    }
  },

  recoverPassword: function () {

    this.model.set('errorMessage', '');
    this.model.set('successMessage', '');
    this.model.set("validationSuspended", false);
    if(this.model.isValid(true)) {
      this.model.set('isProcessing', true);
      $.ajax({
        url: bookedby.routes.AUTHENTICATION.RECOVER_PASSWORD,
        contentType: 'application/json',
        method: 'POST',
        data: JSON.stringify({
          storeGroupUuid: bookedby.staticData.storeGroupId,
          email: this.model.get('email')
        }),
        dataType: 'json',
        success: _.bind(function(data) {
          this.model.set('isProcessing', false);
          if (data.success) {
            this.model.set('successMessage', 'An email with the password recovery information has been sent to you');

            this.$('#recoveredPassword').focus();
          }
          else if (data.userError) {
            this.model.set('errorMessage', data.error);
          } else {
            bookedby.app.logAPIError(data.error);
          }
        }, this),
        error: _.bind(function(jqXHR, textStatus, textError) {
          this.model.set('isProcessing', false);
          bookedby.app.logAPIError(textError);
        }, this)
      });
    }
  },

  closeModal: function() {
    this.$el.modal('hide');
  }
});

module.exports = ChangePasswordForm;